import {
  useTargetAccumulatorSelector,
  useTargetAccumulatorTileId,
} from '@/App/tiles/TargetAccumulator/TargetAccumulatorContext.tsx';
import { TraderInfos } from '@/components/TraderInfos.tsx';
import { getTargetAccumulatorContribution, getTargetAccumulatorTraderId } from '@/store/targetAccumulator/selectors.ts';

const TargetAccumulatorTraderInfos = () => {
  const traderId = useTargetAccumulatorSelector(getTargetAccumulatorTraderId);
  const tileId = useTargetAccumulatorTileId();
  const contribution = useTargetAccumulatorSelector(getTargetAccumulatorContribution);

  return <TraderInfos contribution={contribution} tileId={tileId} traderId={traderId} />;
};

export default TargetAccumulatorTraderInfos;
